import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import moment from 'moment';

/**
 * Marks a subscription that was canceled but is still active until `cancelAt`.
 * Such a subscription is left out of MRR.
 */
function CancelingSign({ cancelAt, title }) {
  return (
    <Tooltip
      title={title || `Canceled, active until ${moment(cancelAt).format('YYYY-MM-DD')} (not counted in MRR)`}
    >
      <WarningOutlined style={{ color: 'red', marginLeft: 4, cursor: 'help' }} />
    </Tooltip>
  );
}

CancelingSign.propTypes = {
  cancelAt: PropTypes.string,
  title: PropTypes.node,
};

CancelingSign.defaultProps = {
  cancelAt: null,
  title: null,
};

export default CancelingSign;
